import React, { Component } from 'react';
import { Button } from 'react-bootstrap';
import { hubAccessLevels } from '../../constant/config';
import CarouselSection from './CarouselSection';
import ModulesTab from '../common/ModulesTab';
import './HomeTab.css';


class HomeTab extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showingInfo : false,
    };
  }

  getNoModuleContent() {
    if (this.props.hub.userAccessLevel >= hubAccessLevels.HUB_ADMIN) {
      return (
        <div className="no-modules">
          <div className="no-module-text">
          This hub does not have any modules yet, to get started create your first module in the Create tab above.
          </div>
        </div>
      );
    }
  }

  onMakeFeaturedClick() {
    this.props.changeToSettingsTab();
  }

  getNoFeaturedModule() {
      return (
        <div className="no-modules">
          <div className="no-module-text">
            <h3 className="section-title">
              <div>
                Featured Modules
              </div>
              <span>
                <Button
                  className="select-featured-button"
                  onClick={() => this.onMakeFeaturedClick()}
                >
                  Select Featured Modules  →
                </Button>
              </span>
            </h3>
            <div className="sub-title">There are no featured modules selected</div>
            <div className='description'>
              Featuring will let your users know about the content your hub has at a glance. You can choose to set eight featured modules from Hubs > Settings > Featured Modules, or click on the ‘Select Featured Modules’ button above.
            </div>
          </div>
        </div>
      );
  }

 

  render() {
    let infoHeaderModule;
    let infoHeaderFolder;
    let infoTextModule;
    let infoTextFolder;

    if (this.props.hub.userAccessLevel >= hubAccessLevels.HUB_ADMIN) {
      infoHeaderModule = "What are Featured Modules?"
      infoTextModule = "Featuring will let your users know about the content your hub has at a glance. You can choose to set eight featured modules from Hubs > Settings > Featured Modules."
      infoHeaderFolder = "What are Featured Folders?"
      infoTextFolder = "Featuring will let your users know about the content your hub has at a glance. You can choose to set eight featured folders from Hubs > Settings > Featured Folders."
    }
    const modulesFeatured = this.props.featuredModules;
    return (
      <div className="home-tab-container">
          {!modulesFeatured.length > 0 && this.props.hub.userAccessLevel >= hubAccessLevels.HUB_ADMIN && 
          <div className="featured-modules">
            {this.getNoFeaturedModule()}
            </div>
            }
          {modulesFeatured.length > 0 && 
            <div className="featured-modules">
            <CarouselSection
              noExpand
              context="modules"
              title="Featured Modules"
              tiles={modulesFeatured}
              infinite={true}
              infoHeader={infoHeaderModule}
              infoText={infoTextModule}
            />
            </div>
          }
         <hr className="hr-line"></hr>
        <div className={this.props.hub.active_filter? 'home-main-with-filter-container':'home-main-container'}>
          <ModulesTab
            modules={this.props.modules}
            hub={this.props.hub}
            changeTab={this.props.changeTab}
            user={this.props.user}
            bookmarks={this.props.bookmarks}
            tagList={this.props.tagList}
            fromHomeTab = {true}
          />
        </div>
      </div>
    );
  }
}

export default HomeTab;
